import {
  VuexModule,
  Module,
  getModule,
  Mutation,
  Action,
} from "vuex-module-decorators";
import store from "@/store";
import { FiltroPrestadorModel } from "@/models/cadastros/assistencia/FiltroPrestadorModel";
import { FiltroAgenteModel } from "@/models/cadastros/assistencia/agente/FiltroAgenteModel";

export interface IFiltroCadastrosStore extends VuexModule {
  filtroPrestadorModel: FiltroPrestadorModel | null;
  filtroAgenteModel: FiltroAgenteModel | null;
}

const getDefaultState = () => {
  return {
    filtroPrestadorModel: null,
    filtroAgenteModel: null
  };
};

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "FiltroCadastros",
})
class FiltroCadastrosStore extends VuexModule implements IFiltroCadastrosStore {
  filtroPrestadorModel: FiltroPrestadorModel | null = null;
  filtroAgenteModel: FiltroAgenteModel | null = null;

  @Mutation
  RESET() {
    Object.assign(this, getDefaultState());
  }

  @Mutation
  SET_FILTRO_PRESTADORES(payload: FiltroPrestadorModel) {
    this.filtroPrestadorModel = payload;
  }

  get filtroAtualPrestadores() {
    return this.filtroPrestadorModel;
  }

  @Mutation
  SET_FILTRO_AGENTE(payload: FiltroAgenteModel) {
    this.filtroAgenteModel = payload;
  }

  get filtroAtualAgentes() {
    return this.filtroAgenteModel;
  }
}

export const filtroCadastrosStore = getModule(FiltroCadastrosStore);
